// extracted by mini-css-extract-plugin
export var chatHtmlText = "_p0-2";
export var chatLink = "_p0-0";
export var chatText = "_p0-1";